import { isValidThreadSummary, type ThreadSummary } from 'services/connectivity/agent-chat-api/types/summary';

/**
 * Parses the raw `details` blob of a `subtype: summary` system event into a
 * versioned {@link ThreadSummary}. The returned object mirrors what the backend
 * sent (v0 flat text or v1 structured content) minus `updated_at`, which the
 * caller supplies from the event timestamp. Returns `null` for malformed or
 * unrecognised payloads.
 */
export function parseSummaryDetails(rawDetails: string): ThreadSummary | null {
  try {
    const details = JSON.parse(rawDetails) as { summary?: ThreadSummary };
    const summary = details?.summary;

    return isValidThreadSummary(summary) ? summary : null;
  } catch {
    return null;
  }
}
